var _polygon, _polygon2, _rect, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Flutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#40c4ff",
    points: "26,4 6,24 12,30 38,4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#40c4ff",
    points: "38,22 27,33 21,27 26,22"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.485,
    height: 8.485,
    x: 16.757,
    y: 28.757,
    fill: "#03a9f4",
    transform: "rotate(-45.001 21 33)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#01579b",
    points: "38,44 26,44 21,39 27,33"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#084994",
    points: "21,39 30,36 27,33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Flutter);
export default __webpack_public_path__ + "static/media/icons8-flutter.048226813aa67d3b9c69de4b27f7c1fa.svg";
export { ForwardRef as ReactComponent };